import { Injectable } from '@angular/core';
import { sp } from '@pnp/sp';
import { ListTitles, ListTypes } from 'src/app/services/constants';
import "@pnp/sp/files";
import "@pnp/sp/folders";
@Injectable({
  providedIn: 'root'
})
export class ChannelService {
  private channelPromise: Promise<ChannelService>;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }
  async getSimilarCustomSubclassification(subClassNew: string[]): Promise<any> {
    const filter = `${subClassNew.join(" or ")}`;
    return await sp.web.lists.getByTitle("CustomSubClassification").items
      .filter(filter).getAll();
  }
  async createOthersSubClassificationsifNotExists(PopulationOthers: string, LineOfTherapyOthers: string, ClinicalTrialsOthers: string, PopulationOthersPrevious: string, LineOfTherapyOthersPrevious: string, ClinicalTrialsOthersPrevious: string,): Promise<void> {
    //get population others value. Compare previous and current     
    //get lineoftherapy others value. Compare previous and current
    //get Clinical trial others value . Compare previous and current
    //if new value for any, get if any items exists
    let otherSubClassificationArray = [];
    if (PopulationOthers && (PopulationOthers !== PopulationOthersPrevious)) {
      otherSubClassificationArray.push("SubClassificationValue eq '" + PopulationOthers + "'");
    }

    if (LineOfTherapyOthers && (LineOfTherapyOthers !== LineOfTherapyOthersPrevious)) {
      otherSubClassificationArray.push("SubClassificationValue eq '" + LineOfTherapyOthers + "'");
    }

    if (ClinicalTrialsOthers && (ClinicalTrialsOthers !== ClinicalTrialsOthersPrevious)) {
      otherSubClassificationArray.push("SubClassificationValue eq '" + ClinicalTrialsOthers + "'");
    }

    let similarCustomSubclassifications = await this.getSimilarCustomSubclassification(otherSubClassificationArray);
    let existingcustomSubClassificationItems = [];
    existingcustomSubClassificationItems = similarCustomSubclassifications.filter(x =>
      x["SubClassification"] == "Population" && x["SubClassificationValue"] == PopulationOthers
    );

    const customSubclassificationsToAdd = [];
    if ((existingcustomSubClassificationItems.length <= 0) && PopulationOthers && (PopulationOthers !== PopulationOthersPrevious)) {
      //Add to batch for creating items
      customSubclassificationsToAdd.push(["Population", PopulationOthers]);
    }

    existingcustomSubClassificationItems = [];
    existingcustomSubClassificationItems = similarCustomSubclassifications.filter(x =>
      x["SubClassification"] == "Line of Therapy" && x["SubClassificationValue"] == LineOfTherapyOthers
    );
    if ((existingcustomSubClassificationItems.length <= 0) && LineOfTherapyOthers && (LineOfTherapyOthers !== LineOfTherapyOthersPrevious)) {
      //Add to batch for creating items
      customSubclassificationsToAdd.push(["Line of Therapy", LineOfTherapyOthers]);
    }

    existingcustomSubClassificationItems = [];
    existingcustomSubClassificationItems = similarCustomSubclassifications.filter(x =>
      x["SubClassification"] == "Clinical Trial" && x["SubClassificationValue"] == ClinicalTrialsOthers
    );
    if ((existingcustomSubClassificationItems.length <= 0) && ClinicalTrialsOthers && (ClinicalTrialsOthers !== ClinicalTrialsOthersPrevious)) {
      //Add to batch for creating items
      customSubclassificationsToAdd.push(["Clinical Trial", ClinicalTrialsOthers]);
    }
    await this.addCustomSubClassification(customSubclassificationsToAdd);
  }

  async addCustomSubClassification(customSubClassification: string[]): Promise<void> {
    const list = sp.web.lists.getByTitle("CustomSubClassification");
    const batch = sp.web.createBatch();
    customSubClassification.forEach(customSubClassificationitem => {
      const keywordItem = {
        SubClassification: customSubClassificationitem[0],
        SubClassificationValue: customSubClassificationitem[1]
      };

      list.items.inBatch(batch).add(keywordItem);
    });

    await batch.execute();
  }

  async Ta_Asset_Indication_Country_UpdateChildren(listnames: string[][], actionType: string, parentId: any, previousTA: number, previousIndication: number, previousAsset: number, previousCountry: number, TA: number, Indication: number, Asset: number, Country: number): Promise<void> {
    if ((previousTA != TA) || (previousAsset != Asset) || (previousIndication != Indication) || (previousCountry != Country)) {
      // Update all the lists with new values
      let itemsforBatch = [];
      listnames.forEach(element => {
        let talistsDetailstoUpdate=[];
        talistsDetailstoUpdate.push(actionType);
        talistsDetailstoUpdate.push(element[0]);//ListName
        talistsDetailstoUpdate.push(element[1]);//ListType     
        talistsDetailstoUpdate.push(element[2]);//ParentItemFieldName  
        talistsDetailstoUpdate.push((parentId ?? "").toString());       
        talistsDetailstoUpdate.push((TA ?? "").toString());
        talistsDetailstoUpdate.push((Asset ?? "").toString());
        talistsDetailstoUpdate.push((Indication ?? "").toString());
        talistsDetailstoUpdate.push((Country ?? "").toString());
        itemsforBatch.push(talistsDetailstoUpdate);
      });
      this.createNewPowerAutomateTrigger(itemsforBatch);
    }
  }

  async DeleteAEM_PowerAutomateTrigger(actionType: string, subActionType: string, aemId: any): Promise<void> {
    let itemsforBatch=[];
    let aemItemDelete=[];
    aemItemDelete.push(actionType);
    aemItemDelete.push(subActionType);
    aemItemDelete.push((aemId ?? "").toString());
    itemsforBatch.push(aemItemDelete);
    this.createNewPowerAutomateTrigger(itemsforBatch);
  }

  async DeleteChildrenWhenParentIsDeleted(listnames: string[][], actionType: string, parentId: any) {	
    // Delete all the list items	
    let itemsforBatch = [];	
    listnames.forEach(element => {	
      let childParentDelete=[];	
      childParentDelete.push(actionType);	
      childParentDelete.push(element[0]);//ListName	
      childParentDelete.push(element[1]);//ListType     	
      childParentDelete.push(element[2]);//ParentItemFieldName  	
      childParentDelete.push((parentId ?? "").toString());               	
      itemsforBatch.push(childParentDelete);	
    });	
    this.createNewPowerAutomateTrigger(itemsforBatch);	
  } 	
  async getUsersFromNotificationSubscription(channelName, itemId) {	
    const items = await sp.web.lists.getByTitle(ListTitles.notificationSubscription).items	
      .filter(`ChannelName eq '${channelName}' and ItemID eq '${itemId}'`).getAll();        	
    return items;    	
  }	
  async notification_Subscription(actionType: string, subActionType: string, documentActionType: string, channelName: string, TA_Asset_Indication_Value: string, tabType: string, resourceType: string, fileName: string, modifiedOn: string, actionBy: string, usersArray: any, itemURL: string) {    
    let itemsforBatch = [];
    usersArray.forEach(element => {
      let addUser=[];
      addUser.push(actionType);
      addUser.push(subActionType);
      addUser.push(documentActionType); //whether document is added or deleted
      addUser.push(channelName);
      addUser.push(TA_Asset_Indication_Value); //TA_Asset_Indication value
      addUser.push(tabType); //tab type
      addUser.push(resourceType); //resource type
      addUser.push(fileName); //file name
      addUser.push(modifiedOn); //file modified on
      addUser.push(actionBy); //file modified by
      addUser.push(element.toString());  //List of Users to send mail notification                
      addUser.push(itemURL);  //URL of TA|Asset|Indication               
      itemsforBatch.push(addUser);	
    });	
    this.createNewPowerAutomateTrigger(itemsforBatch);	
  }

  async breakInheritance_onCreate(previousAdditionalUsers: any, AdditionalUsers: any, actionType: string, subActionType: string, itemID: any, listName: any, libraryName: any, creatorsGroupName: any, ownersGroupName: any, additionalLibraryName: any): Promise<void> {
    let itemsforBatch = [];
    let breakInheritance = [];
    if (previousAdditionalUsers == undefined && AdditionalUsers.length >= 0) {
      breakInheritance.push(actionType);
      breakInheritance.push(subActionType);
      breakInheritance.push((itemID ?? "").toString());
      breakInheritance.push(listName);
      breakInheritance.push(libraryName);
      breakInheritance.push(creatorsGroupName);
      breakInheritance.push(ownersGroupName);
      breakInheritance.push(additionalLibraryName);
      itemsforBatch.push(breakInheritance);
      this.createNewPowerAutomateTrigger(itemsforBatch);
    }        
  }
  
  async breakInheritance_onUpdate(previousAdditionalUsers: any, AdditionalUsers: any, actionType: string, subActionType: string, itemID: any, listName: any, libraryName: any, creatorsGroupName: any, ownersGroupName: any, additionalLibraryName: any): Promise<void> {
    let itemsforBatch = [];
    let breakInheritance = [];    
    if ((previousAdditionalUsers != undefined && previousAdditionalUsers.sort().join(',')) != (AdditionalUsers != undefined && AdditionalUsers.sort().join(','))) {	
      breakInheritance.push(actionType);	
      breakInheritance.push(subActionType);	
      breakInheritance.push((itemID ?? "").toString());	
      breakInheritance.push(listName);	
      breakInheritance.push(libraryName);	
      breakInheritance.push(creatorsGroupName);	
      breakInheritance.push(ownersGroupName);	
      breakInheritance.push(additionalLibraryName);	
      itemsforBatch.push(breakInheritance);	
      this.createNewPowerAutomateTrigger(itemsforBatch);	
    }    
  }

  async breakInheritance_AccessCommunities(actionType: string, subActionType: string, itemID: any, listName: any, libraryName: any): Promise<void> {	
    let itemsforBatch = [];	
    let breakInheritance = [];        	
    breakInheritance.push(actionType);		
    breakInheritance.push(subActionType);		
    breakInheritance.push((itemID ?? "").toString());		
    breakInheritance.push(listName);		
    breakInheritance.push(libraryName);	    	
    itemsforBatch.push(breakInheritance);		
    this.createNewPowerAutomateTrigger(itemsforBatch);	  	
  }

  async createNewPowerAutomateTrigger(itemsforBatch: any[]): Promise<void> {
    const batch = sp.web.createBatch();
    const list = sp.web.lists.getByTitle(ListTitles.PATriggerManagementList);
    itemsforBatch.forEach(element => {
      list.items.inBatch(batch)
        .add({
          Action: !!element[0]?element[0]:"-",
          Param1: !!element[1]?element[1]:"-",
          Param2: !!element[2]?element[2]:"-",
          Param3: !!element[3]?element[3]:"-",
          Param4: !!element[4]?element[4]:"-",
          Param5: !!element[5]?element[5]:"-",
          Param6: !!element[6]?element[6]:"-",
          Param7: !!element[7]?element[7]:"-",
          Param8: !!element[8]?element[8]:"-",
          Param9: !!element[9]?element[9]:"-",
          Param10: !!element[10]?element[10]:"-",
          Param11: !!element[11]?element[11]:"-"
        })
    });
    await batch.execute();
  }
}
